import React from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {SpinnerBox} from './boxes/spinner/spinner.box';
import {SpinnerBrandBox} from './boxes/spinner-brand/spinner-brand.box';
import {SpinnerBackgroundBox} from './boxes/spinner-background/spinner-background.box';
import {SpinnerLogoBox} from './boxes/spinner-logo/spinner-logo.box';
import {CyClass} from '../../../common/cy-classes';
import {SpinnerSubtextBox} from "./boxes/spinner-subtext/spinner-subtext.box";

export const SpinnerComponent = observer(class SpinnerComponent extends OrbitComponent<{}> {

    private _renderSubText(): React.ReactNode {
        if (this.services.spinner.isTheMigrationSpinnerActive) {
            return (
              <SpinnerSubtextBox>{this.services.translation.translate('LOGGING_IN')}</SpinnerSubtextBox>
            );
        }
        return null;
    }

    render() {

        if (!this.services.spinner.isSpinning) {
            return null;
        }

        return (
            <SpinnerBox isMigrationSpinner={this.services.spinner.isTheMigrationSpinnerActive} className={CyClass('cy-spinner')}>
                <SpinnerBrandBox className='cy-spinner-brand'>
                    <SpinnerBackgroundBox className='cy-spinner-background'/>
                    <SpinnerLogoBox className='cy-spinner-logo' isRTL={this.services.language.isRTLLanguage} />
                    {this._renderSubText()}
                </SpinnerBrandBox>
            </SpinnerBox>
        );
    }
});
